// 9fbef606107a605d69c0edbcd8029e5d
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import bagPageActions from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.actions';
import SpcSelector, {
  getSavedContactDetails,
} from '@tcp/core/src/components/features/CnC/SinglePageCheckout/container/SinglePageCheckout.selector';
import PropTypes from 'prop-types';
import {
  getLedgerSummaryData,
  getApplePayDisc,
  getShippingTotal,
  getProductTotal,
} from '@tcp/core/src/components/features/CnC/common/organism/OrderLedger/container/orderLedger.selector';
import { getBasketId } from '@tcp/core/src/utils';
import {
  isPlccUser,
  getCurrentPointsState,
} from '@tcp/core/src/components/features/account/User/container/User.selectors';
import {
  getIsDefaultApplePayAbTest,
  getIsDynamicFreeShippingEnabled,
  getIsOptimizeApplePaySheet,
  getIsPersistPointsApiEnabled,
  getIsSuppressApplePayEmailFieldEnabled,
  isUpdateCallOnApplepayInitEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { setLoaderState } from '@tcp/core/src/components/common/molecules/Loader/container/Loader.actions';
import BagPageSelectors, {
  getLoyaltyPointsRequestPayload,
  getFreeShippingThresholdValue,
} from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.selectors';
import {
  getOrderEddDates,
  getEddABState,
  getEddFeatureSwitch,
} from '@tcp/core/src/components/features/CnC/common/molecules/EddComponent/container/EddComponent.selectors';
import { toastMessageInfo } from '@tcp/core/src/components/common/atoms/Toast/container/Toast.actions';
import { getBossUnavailableProduct } from '@tcp/core/src/components/features/CnC/CartItemTile/molecules/BossUnavailableTile/container/BossUnavailable.selector';
import ApplePaymentButton from '../views';
import selectors, {
  isGuest as isGuestUser,
  getIsApplePayEnabled,
  getPickupValues,
  getAppleLoderState,
  getPickupAltValues,
  isRemembered,
} from '../../../../features/CnC/Checkout/container/Checkout.selector';
import {
  getCartOrderId,
  getOrderShipments,
} from '../../../../features/CnC/CartItemTile/container/CartItemTile.selectors';
import CHECKOUT_ACTIONS, {
  getAppleClientToken,
  setApplePaymentInProgress,
  submitBillingSection,
  setApplePayAppData,
  fetchShipmentMethods,
  getSetCheckoutStage,
  getAppleClientTokenSuccess,
  checkoutSetCartData,
} from '../../../../features/CnC/Checkout/container/Checkout.action';
import { APPLE_USER_STATES } from './ApplePaymentButton.util';
import { getAddressList } from '../../../../features/account/AddressBook/container/AddressBook.actions';
import { getAddressListState } from '../../../../features/account/AddressBook/container/AddressBook.selectors';
import {
  setAppleWalletSetup,
  updateSectionState,
} from '../../../../features/CnC/SinglePageCheckout/container/SinglePageCheckout.actions';
import { SPC_SECTION } from '../../../../features/CnC/SinglePageCheckout/container/SinglePageCheckout.constants';
import { simulateLoyaltyDetail } from '../../../../features/CnC/LoyaltyBanner/container/Loyalty.actions';
import { getCouponList } from '../../../../features/CnC/common/organism/CouponAndPromos/container/Coupon.actions';

export const ApplePaymentButtonContainer = (props) => {
  const { authorizationKey, isGuest, orderId, getApplePaymentTokenAction } = props;
  const [createAppleInstance, setCreateAppleInstance] = useState(false);
  const [createdAppleInstanceState, setCreatedAppleInstanceState] = useState(false);
  const setApplePaymentProgress = (payloadParam) => {
    const { setAppleProgress } = props;
    setAppleProgress(payloadParam);
  };

  const submitBillingApple = (payloadParam) => {
    const { submitBilling } = props;
    submitBilling(payloadParam);
  };

  const appleClientToken = () => {
    const userState = isGuest ? APPLE_USER_STATES.GUEST : APPLE_USER_STATES.REGISTERED;
    getApplePaymentTokenAction({ userState, orderId });
  };

  useEffect(() => {
    const { applePayLoadinginProgress } = props;
    if (!authorizationKey && applePayLoadinginProgress === false) {
      appleClientToken();
    }
  }, []);

  useEffect(() => {
    if (authorizationKey && !createdAppleInstanceState) {
      setCreateAppleInstance(true);
    }
  }, [authorizationKey]);

  const createdAppleInstance = (data) => {
    if (data) {
      setCreatedAppleInstanceState(true);
    }
  };

  return authorizationKey ? (
    <ApplePaymentButton
      setApplePaymentInProgressView={setApplePaymentProgress}
      submitAppleBillingSection={submitBillingApple}
      createAppleInstance={createAppleInstance}
      createdAppleInstance={createdAppleInstance}
      {...props}
    />
  ) : null;
};

ApplePaymentButtonContainer.propTypes = {
  setAppleProgress: PropTypes.func,
  submitBilling: PropTypes.func,
  getApplePaymentTokenAction: PropTypes.func.isRequired,
  isGuest: PropTypes.bool.isRequired,
  authorizationKey: PropTypes.string.isRequired,
  orderId: PropTypes.string.isRequired,
  getAddressListAction: PropTypes.func,
  applePayLoadinginProgress: PropTypes.bool.isRequired,
};

ApplePaymentButtonContainer.defaultProps = {
  setAppleProgress: () => {},
  submitBilling: () => {},
};

const { getAppleClientTokenData, getShipmentMethods, getApplePayEligibleShippingState } = selectors;
const {
  getShippingModeID,
  getErrorMapping,
  getShippingContactForApplePay,
  getOrderType,
  getCartStoresToJs,
} = BagPageSelectors;
const mapStateToProps = (state) => {
  const appleClientTokenData = getAppleClientTokenData(state);
  const shipModeId = getShippingModeID(state);
  const { clientToken: authorizationKey } = appleClientTokenData || {};
  const pageLedgerSummaryData = getLedgerSummaryData(state);
  const applePayDisc = getApplePayDisc(state) || 0;
  const { couponsTotal = 0, orderBalanceTotal = 0 } = pageLedgerSummaryData;
  const shipmentMethods = getShipmentMethods(state);
  const allowedApplePayStates = getApplePayEligibleShippingState(state);
  const errorLabels = getErrorMapping(state);
  const shippingContact = getShippingContactForApplePay(state);
  const orderId = getCartOrderId(state) || '';
  const applePayAppData = selectors.getApplePayAppDataApp(state);
  const basketId = getBasketId();
  const { loading, isEligibleForApplePay } = applePayAppData;
  const loyaltyPointsRequestPayload = getLoyaltyPointsRequestPayload(state);

  const stores = getCartStoresToJs(state);
  return {
    isApplePayEnabled: getIsApplePayEnabled(state),
    isGuest: isGuestUser(state),
    orderId: orderId.toString(),
    authorizationKey,
    pageLedgerSummaryData: {
      ...pageLedgerSummaryData,
      couponsTotal: couponsTotal + applePayDisc,
      orderBalanceTotal: orderBalanceTotal - applePayDisc,
    },
    shipmentMethods,
    errorLabels,
    shippingContact,
    shipModeId,
    loading,
    isEligibleForApplePay,
    allowedApplePayStates,
    isEDD: getEddFeatureSwitch(state),
    orderEddDates: getOrderEddDates(state),
    stores,
    basketId,
    orderType: getOrderType(state),
    isEddABTest: getEddABState(state),
    isSPC: SpcSelector.checkIsSinglePageCheckout(state),
    getOrderContactInfo: getSavedContactDetails(state),
    pickUpValues: getPickupValues(state),
    addressList: getAddressListState(state),
    getIsPersistPointsApiEnabled: getIsPersistPointsApiEnabled(state),
    getCurrentPointsState: getCurrentPointsState(state),
    isUserPlcc: isPlccUser(state),
    applePayLoadinginProgress: getAppleLoderState(state),
    isDefaultApplePayAbTest: getIsDefaultApplePayAbTest(state),
    applePayEnabledWithCard: selectors.getApplePayEnabledWithCard(state),
    loyaltyPointsRequestPayload:
      loyaltyPointsRequestPayload && JSON.parse(JSON.stringify(loyaltyPointsRequestPayload)),
    freeShippingThershold: getFreeShippingThresholdValue(state),
    shippingTotal: getShippingTotal(state),
    isDynamicFreeShippingEnabled: getIsDynamicFreeShippingEnabled(state),
    shipments: getOrderShipments(state),
    productTotal: getProductTotal(state),
    isOptimizeApplePaySheetEnabled: getIsOptimizeApplePaySheet(state),
    bossUnavailableProducts: getBossUnavailableProduct(state),
    pickUpAlternatePerson: getPickupAltValues(state),
    isSuppressApplePayEmailFieldEnabled: getIsSuppressApplePayEmailFieldEnabled(state),
    isRememberedUser: isRemembered(state),
    enableUpdateCallOnInit: isUpdateCallOnApplepayInitEnabled(state),
  };
};

export const mapDispatchToProps = (dispatch) => ({
  getApplePaymentTokenAction: (data) => dispatch(getAppleClientToken(data)),
  setApplePayAppDataAction: (data) => dispatch(setApplePayAppData(data)),
  setAppleProgress: (data) => dispatch(setApplePaymentInProgress(data)),
  submitBilling: (payload) => dispatch(submitBillingSection(payload)),
  setCartData: (payload) => dispatch(bagPageActions.getOrderDetailsCompleteApplePay(payload)),
  setCheckoutCartData: (payload) => dispatch(checkoutSetCartData(payload)),
  loadShipmentMethods: (formName) => dispatch(fetchShipmentMethods(formName)),
  getSetCheckoutStage: (data) => dispatch(getSetCheckoutStage(data)),
  routeForBagCheckout: (payload) => dispatch(bagPageActions.routeForCheckout(payload)),
  getAppleClientTokenSuccess: (payload) => dispatch(getAppleClientTokenSuccess(payload)),
  openOOSModal: (payload) => dispatch(bagPageActions.openApayUnqualifiedItemsModal(payload)),
  showBagLoader: (data) => dispatch(setLoaderState(data)),
  displayServerErrorCheckout: (payload) =>
    dispatch(CHECKOUT_ACTIONS.setServerErrorCheckout(payload)),
  toastMessage: (payload) => {
    dispatch(toastMessageInfo(payload));
  },
  getAddressListAction: () => {
    dispatch(getAddressList());
  },
  updateSectionState: (payload) => {
    dispatch(updateSectionState({ id: SPC_SECTION.PAYMENT, section: payload }));
  },
  simulateLoyaltyDetail: (payload) => {
    dispatch(simulateLoyaltyDetail(payload));
  },
  setAppleWallet: (payload) => {
    dispatch(setAppleWalletSetup(payload));
  },
  fetchCoupons: (payload) => {
    dispatch(getCouponList(payload));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ApplePaymentButtonContainer);
